import LogoutDialog from 'components/Dialogs/Logout';
import { IAppRoute } from 'interfaces/route';
import * as React from 'react';
import { PureComponent } from 'react';
import { Redirect, RouteComponentProps } from 'react-router-dom';
import rxjsOperators from 'rxjs-operators';
import authService from 'services/auth';
import { RouterContext } from '..';

interface IState {
  isAuthenticated: boolean;
  canAccess: boolean;
  didMount: boolean;
}

interface IProps {
  route: IAppRoute;
  routeProps: RouteComponentProps<any>;
}

export default class AppRouterProtected extends PureComponent<IProps, IState> {
  constructor(props: any) {
    super(props);
    this.state = { isAuthenticated: false, canAccess: false, didMount: false };
  }

  componentDidMount() {
    authService
      .getUser()
      .pipe(rxjsOperators.logError(), rxjsOperators.bindComponent(this))
      .subscribe((user) => {
        if (!user) {
          return this.setState({
            isAuthenticated: false,
            canAccess: false,
            didMount: true,
          });
        }

        const canAccessUser = user.canAccess(...(this.props.route.roles || []));
        const { canAccess, isAuthenticated } = this.state;
        if (canAccessUser !== canAccess)
          this.setState({ canAccess: canAccessUser });
        if (!isAuthenticated) this.setState({ isAuthenticated: true });

        if (!this.state.didMount) {
          this.setState({ didMount: true });
        }
      });

  }

  render(): JSX.Element {
    const { isAuthenticated, canAccess, didMount } = this.state;
    const { route, routeProps, children } = this.props;

    if (!didMount) {
      return null as any;
    }

    if (!isAuthenticated) {
      return (
        <RouterContext.Consumer>
          {(routerGetter) => <LogoutDialog appRouter={routerGetter()} />}
        </RouterContext.Consumer>
      );
    }

    if (!canAccess) {
      return <Redirect to="/" />;
    }

    return <route.component {...routeProps}>{children}</route.component>;
  }
}
